Vue.component("image-boxes-carousel", {

    template: `<div>
        <div class="loader-wrapper" ref="loader">
            <div class="loader">
                <div class="dot"></div><div class="dot"></div><div class="dot"></div><div class="dot"></div>
                <div class="dot"></div><div class="dot"></div><div class="dot"></div><div class="dot"></div>
            </div>
        </div>
        <div v-if="imageboxes.length > 0" class="owl-carousel owl-carousel-imagebox owl-theme" ref="carousel">
            <div class="item" v-for="(imagebox, index) in imageboxes">
                <a :href="imagebox.url" class="banner">
                    <span class="figure">
                        <img v-if="imagebox.imageUrl" class="owl-lazy" :data-src="imagebox.imageUrl" :alt="imagebox.name">
                        <span class="figcaption" v-if="imagebox.name || imagebox.buttonText">
                            <span class="block-table">
                                <span class="block-table-cell">
                                    <span v-if="imagebox.name" class="banner__title">\${ imagebox.name }</span>
                                    <span v-if="imagebox.buttonText" class="btn btn-primary btn-shop-link">\${ imagebox.buttonText }</span>
                                </span>
                            </span>
                        </span>
                    </span>
                </a>
            </div>
        </div>
    </div>`,

    props: {
        imageboxesData: {
            type: Array
        },
        responsiveOne: {
            type: Number,
            default: 1
        },
        responsiveTwo: {
            type: Number,
            default: 2
        },
        responsiveThree: {
            type: Number,
            default: 3
        }
    },

    computed: {
        imageboxes()
        {
            return this.imageboxesData;
        }
    },

    mounted()
    {
        this.$nextTick(() =>
        {
            if (this.imageboxes && this.imageboxes.length > 0)
            {
                this.initializeCarousel();
            }
        });
    },

    methods: {
        initializeCarousel()
        {
            const noMargin = $(this.$refs.carousel).closest(".widget-image-boxes-carousel").hasClass("full-width");

            $(this.$refs.carousel).owlCarousel({
                dots: false,
                loop: this.imageboxes.length >= this.responsiveThree,
                lazyLoad: true,
                margin: (noMargin ? 0 : 15),
                nav: true,
                navText: [
                    `<i id="owl-nav-text-left-${this._uid}" class='fa fa-chevron-left' aria-hidden='true'></i>`,
                    `<i id="owl-nav-text-right-${this._uid}" class='fa fa-chevron-right' aria-hidden='true'></i>`
                ],
                responsiveClass: true,
                responsive: {
                    0: {
                        items: this.imageboxes.length >= this.responsiveOne ? this.responsiveOne : this.imageboxes.length
                    },
                    600: {
                        items: this.imageboxes.length >= this.responsiveTwo ? this.responsiveTwo : this.imageboxes.length
                    },
                    1000: {
                        items: this.imageboxes.length >= this.responsiveThree ? this.responsiveThree : this.imageboxes.length
                    }
                },
                onInitialized: event =>
                {
                    $(this.$refs.loader).addClass("loaded");

                    document.querySelector(`#owl-nav-text-left-${this._uid}`).parentElement.onclick = event => event.preventDefault();
                    document.querySelector(`#owl-nav-text-right-${this._uid}`).parentElement.onclick = event => event.preventDefault();
                }
            });
        }
    }
});

Vue.component("image-slider-pro", {
    template: `<div class="slider-pro" ref="slider">
        <div class="sp-slides">
            <slot></slot>
        </div>
    </div>`,

    props: {
        sliderOptions: {
            type: Object,
            default: () => ({
                width: "100%",
                autoHeight: true,
                loop: true,
                arrows: true,
                buttons: true,
                waitForLayers: true,
                autoplay: true,
                autoplayDelay: 5000,
                autoScaleLayers: false,
                smallSize: 576,
                mediumSize: 992,
                largeSize: 1200,
                keyboard: false,
                reachVideoAction: "playVideo",
                heightAnimationDuration: 0
            })
        }
    },

    mounted()
    {
        this.$nextTick(() =>
        {
            this.initializeCarousel();
        });
    },

    methods: {
        initializeCarousel()
        {
            if (App.isShopBuilder)
            {
                this.sliderOptions.autoplay = false;
            }

            if (!App.isShopBuilder)
            {
                const isMobile = window.matchMedia("(max-width: 768px)").matches;

                if ( isMobile )
                {
                    $(this.$refs.slider).find(".sp-slide[data-mob-only]").remove();
                }
            }
            if ( $(this.$refs.slider).find(".sp-slides").children().length <= 1 )
            {
                this.sliderOptions.loop = false;
                this.sliderOptions.arrows = false;
            }
            $(this.$refs.slider).sliderPro(this.sliderOptions);
        }
    }
});

$(function()
{
    if (!App.isShopBuilder)
    {
        if ($("#mainTopMenuWrapper").attr("data-sticky") == "true")
        {
            // Check the initial Poistion of the Sticky Header
            const stickyHeaderTop = $("#mainTopMenuWrapper").offset().top;

            $(window).scroll(function()
            {
                if ($(window).scrollTop() > stickyHeaderTop && $("#mainTopMenuWrapper").is(":visible"))
                {
                    $("#mainTopMenuWrapper").addClass("sticky");
                }
                else
                {
                    $("#mainTopMenuWrapper").removeClass("sticky");
                }
            });
        }

        if ($("#mobileTopMenuWrapper").attr("data-sticky") == "true")
        {
            // Check the initial Poistion of the Sticky Header
            const stickyMobileHeaderTop = $("#mobileTopMenuWrapper").offset().top;

            $(window).scroll(function()
            {
                if ($(window).scrollTop() > stickyMobileHeaderTop && $("#mobileTopMenuWrapper").is(":visible"))
                {
                    $("#mobileTopMenuWrapper").addClass("sticky");
                }
                else
                {
                    $("#mobileTopMenuWrapper").removeClass("sticky");
                }
            });
        }
    }

    $(document).on("mouseenter mouseleave", ".cmp-product-thumb", function()
    {
        $(this).find(".owl-carousel").trigger("refresh.owl.carousel");
    });

    /* Search */
    $(".search__trigger").on("click", function(event)
    {
        event.preventDefault();
        if ($(this).hasClass("opened"))
        {
            $(this).removeClass("opened");
            $(this).find(".pl-outline-clear").removeClass("pl-outline-clear").addClass("pl-baseline-search");
            $(this).parent(".search").removeClass("open");
            $(this).next(".search-dropdown").removeClass("open");
        }
        else
        {
            $(this).addClass("opened");
            $(this).find(".pl-baseline-search").removeClass("pl-baseline-search").addClass("pl-outline-clear");
            $(this).parent(".search").addClass("open");
            $(this).next(".search-dropdown").addClass("open");
        }
    });

    /* Slider-Pro Shopbuilder */
    if (App.isShopBuilder)
    {
        setTimeout(()=>
        {
            $(".slider-pro").sliderPro("update");
        }, 2000);
    }
    $("body").on("click", ".slider-pro-reload", function()
    {
        $(".slider-pro").sliderPro("update");
        return false;
    });

    $("body").on("click", ".slider-pro-switch", function()
    {
        const id = $(this).attr("data-slide");
        const widget = $(this).closest(".widget-slider-container");

        widget.find(".slider-pro-switch").removeClass("active");
        $(this).addClass("active");
        if (id)
        {
            widget.find(".slider-pro").sliderPro("gotoSlide", id);
        }
        return false;
    });

    /* Fake filter */
    $(".fake-filter-toggle").on("click", function()
    {
        $("body").addClass("menu-is-visible");
        $(".customf-side-bar").addClass("open");

        return false;
    });
    $(".customf-side-bar-close").on("click", function()
    {
        $("body").removeClass("menu-is-visible");
        $(".customf-side-bar").removeClass("open");
    });

    /* Collapse block */
    $(".collapse-block__content").each(function()
    {
        if ($(this).parent(".collapse-block").hasClass("open"))
        {
            $(this).slideDown(0);
        }
    });

    $("body").on("click", ".collapse-block__title", function(event)
    {
        event.preventDefault();
        const speed = 300;
        const thisItem = $(this).parent();
        const nextLevel = $(this).next(".collapse-block__content");

        if (thisItem.hasClass("open"))
        {
            thisItem.removeClass("open");
            nextLevel.slideUp(speed);
        }
        else
        {
            thisItem.addClass("open");
            nextLevel.slideDown(speed);
        }
    });

    $(".dropdown-menu__close").on("click", function(event)
    {
        event.preventDefault();
        $(this).closest(".dropdown.open .dropdown-toggle").dropdown("toggle");
    });
});
